module.exports = __webpack_public_path__ + "media/images/bg_top_service-a94f76d485b06a39a23a843af31ad1e9.jpg";